// extracted by mini-css-extract-plugin
module.exports = {"container":"ReviewText_container_3cMBo","label":"ReviewText_label_3Ud8H","value":"ReviewText_value_3w2wP","hint":"ReviewText_hint_14_vk"};